import { render, staticRenderFns } from "./WorkerEducationsForm.vue?vue&type=template&id=4e5ca97e&scoped=true&"
import script from "./WorkerEducationsForm.vue?vue&type=script&lang=js&"
export * from "./WorkerEducationsForm.vue?vue&type=script&lang=js&"
import style0 from "./WorkerEducationsForm.vue?vue&type=style&index=0&id=4e5ca97e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5ca97e",
  null
  
)

export default component.exports